"use client";

import * as React from "react";
import { paymentLinks } from "../constants/paymentLinks";
import TwoColumnLayout from "@/components/institution/TwoColumnLayout";
import paymentsImage from "@/assets/img/payments.png";
import { useParams } from "next/navigation";
const NewPaymentSection: React.FC<{
  baseUrl: string;
}> = ({
  baseUrl
}) => {
  // const params = useParams();
  // const baseUrl = `/${params.locale}/uat/${params.country}/${params.county}/${params.city}/new-payment`;

  return <TwoColumnLayout title="Ai de efectuat o plată?" description="Suntem aici să te ajutăm, alege una din opțiunile de mai jos:" links={paymentLinks} imageSrc={paymentsImage} baseUrl={baseUrl} data-sentry-element="TwoColumnLayout" data-sentry-component="NewPaymentSection" data-sentry-source-file="NewPaymenSection.tsx" />;
};
export default NewPaymentSection;